module.exports = __webpack_public_path__ + "static/3-24f7b0944e9e03a905f9d7701573b2cd.woff2";